<template>
  <div class="outer-tier-container">
    <div>
      <div
        v-if="tiers_settings.enabled && (showSaveButton || tiers.length > 0)"
        class="d-flex flex-row justify-space-around"
      >
        <v-col class="d-flex flex-column">
          <v-toolbar flat class="mb-4 d-flex flex-row">
            <v-btn
              color="secondary"
              class="text-capitalize px-5"
              depressed
              :loading="loading || tiersLoading"
              :disabled="!showSaveButton || !getPermission('point_packages.update')"
              @click="saveChanges"
              >{{ translations.saveChanges[lang] }}</v-btn
            >
            <v-btn
              color="secondary"
              class="text-capitalize px-5 ml-4"
              :loading="loading || tiersLoading"
              depressed
              :disabled="!showResetButton"
              @click="resetChanges"
              >{{ translations.resetChanges[lang] }}</v-btn
            >
          </v-toolbar>

          <v-toolbar flat class="mb-4 d-flex flex-row">
            <b-select
              v-model="currentTiersNumber"
              :items="tierNumberValues"
              :label="translations.tiersNumber[lang]"
              no-clear-icon
              @change="handleTierNumberChange"
            >
            </b-select>
          </v-toolbar>
        </v-col>
        <v-toolbar flat class="mb-4 d-flex flex-row justify-end">
          <v-btn
            color="error"
            class="text-capitalize px-5"
            :loading="loading || tiersLoading"
            depressed
            :disabled="!tiers.length || !getPermission('point_packages.delete')"
            @click="deleteTiersAlert"
            >{{ translations.deleteTiers[lang] }}</v-btn
          >
        </v-toolbar>
      </div>

      <v-toolbar
        v-if="(!showSaveButton && tiers.length === 0) || tiers_settings.enabled === false"
        flat
        class="mb-4"
      >
        <v-btn
          color="secondary"
          class="text-capitalize px-5 mr-4"
          :loading="loading || tiersLoading"
          depressed
          :disabled="!tiers_settings.enabled || !getPermission('point_packages.create')"
          @click="createTiers"
          >{{ translations.createPointTiers[lang] }}</v-btn
        >
      </v-toolbar>
    </div>

    <div v-if="tiers_settings.enabled === false">
      <v-alert color="orange" type="warning" dismissible dense outlined>
        {{ translations.enableTierCreationAlert[lang] }}</v-alert
      >
    </div>
    <div v-else-if="tierValues && tierValues.length > 1" class="d-flex flex-row tiers-container">
      <v-col class="d-flex flex-column">
        <div class="slider-wrapper">
          <v-slider
            v-model="sliderValue"
            :min="0"
            :max="tierValues.length"
            step="1"
            ticks
            :tick-labels="tiersLabels"
            class="tiers-slider"
            :style="{ maxWidth: `${this.tierValues.length * 190}px` }"
          ></v-slider>

          <div :style="{ maxWidth: `${this.tierValues.length * 190}px` }" class="custom-track">
            <div
              v-for="(color, index) in tiersColors"
              :key="index"
              class="segment"
              :style="{
                backgroundColor: color,

                flex:
                  index === tiersColors.length - 1
                    ? 'auto'
                    : '0 0 ' + 100 / tiersColors.length + '%',
              }"
              @click="sliderValue = index"
            ></div>
            <div class="custom-infinity-tick">
              <span @click="sliderValue = tierValues.length - 1" class="mr-n8">∞</span>
            </div>
          </div>
        </div>

        <div class="tiers-cards-container d-flex flex-row mt-6">
          <div
            flat
            v-for="(tier, i) in tierValues"
            :key="`card-${i}-${tier.key}`"
            class="tier-card v-card d-flex align-center mr-0 flex-column pa-2 transition-all"
            :style="{
              gap: '10px',
              cursor: 'pointer',
              background: 'transparent !important',
              width: 100 / tierValues.length + '%',
              minWidth: '190px',
              maxWidth: '190px',
            }"
            @click="sliderValue = i"
          >
            <v-card
              class="d-flex align-center ma-0 pa-2 flex-column"
              :flat="sliderValue != i"
              :raised="sliderValue == i"
              :style="{
                background: sliderValue == i ? '#DEDEDE88' : 'white',
                border: `2px solid ${tier.color}`,
                width: '100%',
                opacity: sliderValue == i ? 1 : 0.8,
                boxShadow:
                  sliderValue == i
                    ? `0 0 9px 3px ${tier.color}88, 0 0 3px 1px ${tier.color}11`
                    : 'none',
              }"
            >
              <v-card-title class="pt-0 justify-space-between tier-card-title">
                <div class="d-flex align-center justify-center" style="flex: 1">
                  <div>
                    <span
                      v-if="tier.title[lang]"
                      class="tier-title-text text-subtitle-1 font-weight-bold mr-2"
                      >{{ tier.title[lang] }}</span
                    >
                    <v-icon
                      v-else
                      color="error"
                      class="mr-2"
                      style="font-size: 1.2em; vertical-align: middle"
                      >mdi-alert</v-icon
                    >
                  </div>
                  <v-tooltip class="tier-edit-tooltip" top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        class="pa-1 mx-1 tier-edit-btn"
                        icon
                        v-on="on"
                        @click="OpenEditTierDialog(i)"
                      >
                        <v-icon color="secondary">mdi-pencil-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ translations.edit[lang] }}</span>
                  </v-tooltip>
                </div>
              </v-card-title>
              <v-col>
                <b-text-field
                  v-model="tier.from"
                  type="number"
                  :color="tier.color"
                  min="0"
                  class="tier-min-field mr-2"
                  :label="
                    tiers_settings.system === 'expiration_mode' ||
                    tiers_settings.package_mode === 'amount'
                      ? translations.startingAmount[lang]
                      : translations[`starting_${storeMode}`][lang]
                  "
                  hide-details
                  dense
                  :readonly="i === 0"
                  :clearable="false"
                  :success="success.minimum_amount[i]"
                  @focus="error.minimum_amount[i] = ''"
                  @blur="adjustPreviousTierMaximumAmountAndValidate(i, tier)"
                ></b-text-field>
              </v-col>
            </v-card>

            <div v-if="tier.errors && tier.errors.length" class="tier-errors mb-2">
              <v-alert
                v-for="(err, idx) in tier.errors"
                :key="idx"
                type="error"
                dense
                outlined
                class="py-1 px-2 mb-1"
                style="font-size: 0.95em"
              >
                {{ err }}
              </v-alert>
            </div>
            <v-divider></v-divider>
          </div>
        </div>
      </v-col>
      <v-dialog
        v-model="editDialog"
        :max-width="$vuetify.breakpoint.smAndDown ? '90%' : '40%'"
        :persistent="!tierValid"
      >
        <PointTierForm
          @close="editDialog = false"
          @submit="submitTierForm"
          :isOpen="editDialog"
          :tierIndex="editTierIndex"
          :tier="tierValues[editTierIndex]"
          :infinity-multiplier="infinityMultiplier"
        />
      </v-dialog>
      <v-dialog v-model="saveDialog" :max-width="$vuetify.breakpoint.smAndDown ? '90%' : '40%'">
        <PointTierAlertDialog
          @close="saveDialog = false"
          @submit="savePointTiers"
          :alert-text="this.translations.confirmSaveMsg[this.lang]"
        />
      </v-dialog>
      <v-dialog v-model="deleteDialog" :max-width="$vuetify.breakpoint.smAndDown ? '90%' : '40%'">
        <PointTierAlertDialog
          @submit="deleteAllTiers"
          @close="deleteDialog = false"
          :alert-text="this.translations.confirmDeleteTiers[this.lang]"
        />
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions } from 'vuex';
import translations from '@/utils/translations/loyaltyPanel/pointTitles';
import validators from '@/utils/validators/loyaltyPanel/pointTiers';
import PointTierForm from './PointTierForm';
import PointTierAlertDialog from './PointTierAlertDialog';
import {
  mdiInfinity,
  mdiPlusCircle,
  mdiMinusCircle,
  mdiPencilOutline,
  mdiAlert,
  mdiArrowUpBold,
  mdiArrowDownBold,
} from '@mdi/js';
import { cloneDeep, isEqual } from 'lodash';

export default {
  name: 'PointTiers',

  components: { PointTierForm, PointTierAlertDialog },
  mixins: [translations, validators],

  data() {
    return {
      icons: {
        mdiInfinity,
        mdiPlusCircle,
        mdiMinusCircle,
        mdiPencilOutline,
        mdiAlert,
        mdiArrowUpBold,
        mdiArrowDownBold,
      },
      titleLang: this.$route.params.lang,
      descLang: this.$route.params.lang,
      editDialog: false,
      saveDialog: false,
      deleteDialog: false,
      tierPointChanged: false,
      savedTiers: [],
      editTier: {},
      editTierIndex: null,
      tiersAreNewlyCreated: false,
      tiersAreDeleted: false,
      dialogPersistent: false,
      tierIndex: 0,
      updatingTiers: false,
      sliderValue: 0,
      maxTiersNumber: 100,
      currentTiersNumber: 0,
      tierValues: [],
    };
  },
  async mounted() {
    await this.fetchPointTitles();
    this.$nextTick(() => {
      this.savedTiers = JSON.parse(JSON.stringify(this.tierValues));
      this.tierPointChanged = false;
      this.injectTickStyles();
    });
  },
  computed: {
    ...mapState('loyaltyPanel/pointTitles', ['tiersLoading', 'tierValid']),
    ...mapState('loyaltyPanel', ['tiers_settings']),
    ...mapState(['loading', 'errorMessage']),
    infinityMultiplier() {
      return (this.tiersData?.length && Math.max(1 + 1 / this.tiersData.length, 1.1)) || 2;
    },

    tiers: {
      get() {
        return this.$store.state.loyaltyPanel.pointTitles.tiers;
      },
      set(val) {
        this.setTiers(val);
      },
    },

    lang() {
      return this.$route.params.lang;
    },
    storeMode() {
      return this.$store.state.store?.display_mode || 'points';
    },
    tiersLabels() {
      let labels = this.tierValues.map((tier) => String(tier.from));
      labels.push('∞');
      return labels;
    },

    tiersColors() {
      let colors = this.tierValues.map((tier) => tier.color);
      return colors;
    },

    title() {
      return this.mode === 1
        ? this.translations.addPointPackage[this.lang]
        : this.translations.updatePointPackage[this.lang];
    },

    pointTitle: {
      get() {
        return this.$store.state.loyaltyPanel.pointTitles.pointTitle;
      },
      set(val) {
        this.setPointTitle(val);
      },
    },
    tierNumberValues() {
      let numbers = [];
      for (let i = 2; i <= this.maxTiersNumber; i++) {
        numbers.push(i);
      }
      return numbers;
    },
    showSaveButton() {
      return this.tiersValid && !isEqual(this.tierValues, this.savedTiers);
    },
    showResetButton() {
      return !isEqual(this.tierValues, this.savedTiers);
    },
  },

  methods: {
    ...mapActions('loyaltyPanel/pointTitles', ['create', 'update', 'fetchPointTitles', 'remove']),
    ...mapMutations('loyaltyPanel/pointTitles', ['setTiers']),
    ...mapMutations(['setNotification']),
    ...mapActions(['getPermission']),

    injectTickStyles() {
      const styleId = 'tiers-slider-tick-styles';
      let oldStyle = document.getElementById(styleId);
      if (oldStyle) oldStyle.remove();

      const style = document.createElement('style');
      style.id = styleId;
      this.tiersColors.forEach((color, index) => {
        style.innerHTML += `
          .tiers-slider .v-slider__tick:nth-child(${index + 1}) {
            background-color: ${color};
          }
        `;
      });
      style.innerHTML += `
        .tiers-slider .v-slider__tick:last-child {
          display: none;
        }
        .custom-infinity-tick {
      border-right: 2px solid ${this.tiersColors[this.tiersColors.length - 1]};
    }
      `;
      document.head.appendChild(style);
    },

    removeTier() {
      let newTiers = this.tierValues;
      newTiers.pop();
      if (newTiers.length === 1) newTiers.pop();
    },
    deleteTiersAlert() {
      this.deleteDialog = true;
    },
    resetChanges() {
      this.tierValues = cloneDeep(this.savedTiers);
      this.resetValidation();
    },

    transformValuesToTiers(values) {
      let tiersData = cloneDeep(values);
      // Remove fields from tiersData that are not present in this.tiers
      const baseLength = Math.min(this.tiers?.length || 0, tiersData?.length || 0);
      for (let idx = 0; idx < baseLength; idx++) {
        const tier = this.tiers[idx] || {};
        const allowedKeys = Object.keys(tier);
        const item = tiersData[idx];
        if (!item || typeof item !== 'object') continue;
        Object.keys(item).forEach((key) => {
          if (!allowedKeys.includes(key)) {
            delete item[key];
          }
        });
      }
      if (tiersData?.[0]?.['expiration_days']) {
        tiersData[0]['expiration_days'] = undefined;
      }

      if (Array.isArray(tiersData)) {
        tiersData.forEach((item) => {
          if (!item || typeof item !== 'object') return;
          if (item.from !== undefined && item.from !== null && item.from !== '') {
            const n = Number(item.from);
            item.from = Number.isNaN(n) ? 0 : n;
          }
          if (item.to !== undefined && item.to !== null && item.to !== '') {
            const m = Number(item.to);
            item.to = Number.isNaN(m) ? undefined : m;
          } else {
            item.to = item.to === '' ? undefined : item.to;
          }
        });
      }
      return tiersData;
    },

    getTierValues() {
      let vals = this.tiers?.map((e, i, a) => {
        if (a.length > 0) {
          let from = typeof e.from === 'number' ? e.from : 0;
          let to = typeof e.to === 'number' ? e.to : from + 10000;

          if (i === a.length - 1) {
            if (!e.to) e.to = parseInt(((from * this.infinityMultiplier) / 100) * 100);
          }
          let key = e.title[this.lang] + e.color + (e.from || 0) + (e.to || 0);

          e.expiration_days =
            (this.tiers_settings.system !== 'expiration_mode' && undefined) || e.expiration_days;
          key += e.expiration_days;
          let lastLimit = a[a.length - 1].to;
          let tierPoints = to - from;
          let width = (lastLimit && `${Math.round((tierPoints * 100) / lastLimit)}%`) || '50%';

          return {
            ...e,
            from,
            to,
            key,
            tierPoints,
            lastLimit,
            width,
          };
        }
        return e;
      });
      this.$set(this, 'tierValues', vals);
      return vals;
    },

    getTiersErrors() {
      for (let [i, tier] of this.tierValues.entries()) {
        this.validateTierForm(i, tier);
        this.validateMinimumAmount(i, tier);
        const tierErrors = [];
        Object.values(this.error).forEach((errorArr) => {
          if (
            Array.isArray(errorArr) &&
            errorArr[i] &&
            typeof errorArr[i] === 'string' &&
            errorArr[i].trim()
          ) {
            tierErrors.push(errorArr[i]);
          }
        });
        this.$set(this.tierValues[i], 'errors', tierErrors);
      }
    },

    async saveChanges() {
      this.getTiersErrors();
      let tiersData = this.transformValuesToTiers(this.tierValues);
      this.setTiers(tiersData);
      if (this.tierPointChanged) {
        return (this.saveDialog = true);
      }
      let res = {};
      if (this.tiersAreNewlyCreated) {
        res = await this.create();
      } else {
        res = await this.update();
      }
      if (res && !res.error) {
        this.$nextTick(() => {
          this.savedTiers = JSON.parse(JSON.stringify(this.tiers));
          this.tiersAreNewlyCreated = false;
        });
      }
    },

    async savePointTiers() {
      if (this.tiers?.[0]?.['expiration_days']) {
        this.tiers[0]['expiration_days'] = undefined;
      }
      let res = {};
      if (this.tiersAreNewlyCreated) {
        res = await this.create();
      } else {
        res = await this.update();
      }
      this.saveDialog = false;
      if (res && !res.error) {
        this.$nextTick(() => {
          this.savedTiers = JSON.parse(JSON.stringify(this.tiers));
          this.tiersAreNewlyCreated = false;
        });
      } else if (
        res &&
        res.message ==
          'System currently maps users to newly updated packages. Please try again later.'
      ) {
        let errorText = {
          en: res.message,
          el: 'Το σύστημα αντιστοιχεί προς το παρόν τους χρήστες σε πρόσφατα ενημερωμένα πακέτα. Προσπαθήστε ξανά αργότερα.',
          it: 'Il sistema attualmente mappa gli utenti verso i pacchetti appena aggiornati. Riprovare più tardi.',
        };
        this.setNotification({
          show: true,
          type: 'error',
          text: errorText[this.lang],
        });
      } else if (res && res.message.includes('expiration days has to be greater than zero')) {
        let errorText = {
          en: 'Expiration days has to be greater than zero (0) in expiration mode',
          el: 'Οι ημέρες λήξεως πρέπει να είναι μεγαλύτερες από το μηδέν (0) στη λειτουργία με χρόνο λήξης.',
          it: 'I giorni di scadenza devono essere maggiori di zero (0) in modalità di scadenza.',
        };
        this.setNotification({
          show: true,
          type: 'error',
          text: errorText[this.lang],
        });
      }
    },

    async deleteAllTiers() {
      await this.remove();
      this.deleteDialog = false;
      this.tiersAreNewlyCreated = true;
    },

    createTiers() {
      this.setTiers([
        {
          title: {
            en: '',
            el: '',
            it: '',
          },
          description: {
            en: '',
            el: '',
            it: '',
          },
          color: '#' + ((Math.random() * 0xffffff) << 0).toString(16).padStart(6, '0'),
          from: 0,
          to: 10000,
        },
        {
          title: {
            en: '',
            el: '',
            it: '',
          },
          description: {
            en: '',
            el: '',
            it: '',
          },
          from: 10001,
          to: 20000,
          expiration_days: this.tiers_settings.system === 'expiration_mode' ? -1 : undefined,
          color: '#' + ((Math.random() * 0xffffff) << 0).toString(16).padStart(6, '0'),
        },
      ]);

      if (!this.savedTiers.length || this.tiersAreDeleted) {
        this.tiersAreNewlyCreated = true;
      }
    },

    addTier() {
      let newTier = {
        title: {
          en: '',
          el: '',
          it: '',
        },
        description: {
          en: '',
          el: '',
          it: '',
        },
        color: '#' + ((Math.random() * 0xffffff) << 0).toString(16).padStart(6, '0'),
        from: 0,
        to: 10000,
        expiration_days: this.tiers_settings.system === 'expiration_mode' ? -1 : undefined,
      };
      if (this.tierValues && this.tierValues.length) {
        let newTiers = this.tierValues;
        newTier.from = newTiers[newTiers.length - 1].to + 1;
        newTier.to = parseInt((newTier.from * this.infinityMultiplier) / 100) * 100;
        newTiers.push(newTier);
      } else {
        this.tierValues = [
          newTier,
          {
            title: {
              en: '',
              el: '',
              it: '',
            },
            description: {
              en: '',
              el: '',
              it: '',
            },
            from: newTier.to + 1,
            to: parseInt((newTier.to * this.infinityMultiplier) / 100) * 100,
            expiration_days: this.tiers_settings.system === 'expiration_mode' ? -1 : undefined,
            color: '#' + ((Math.random() * 0xffffff) << 0).toString(16).padStart(6, '0'),
          },
        ];
      }
    },

    OpenEditTierDialog(i) {
      this.editTier = cloneDeep(this.tierValues[i]);
      this.editTierIndex = i;
      this.editDialog = true;
    },

    submitTierForm({ tier, i }) {
      const nextValues = cloneDeep(this.tierValues);
      const previousTier = nextValues[i] || {};

      const sanitizedTier = cloneDeep(tier);
      delete sanitizedTier.errors;

      const mergedTier = {
        ...previousTier,
        ...sanitizedTier,
        title: sanitizedTier.title ? cloneDeep(sanitizedTier.title) : cloneDeep(previousTier.title),
        description: sanitizedTier.description
          ? cloneDeep(sanitizedTier.description)
          : cloneDeep(previousTier.description),
      };

      mergedTier.key = mergedTier.title?.[this.lang] + mergedTier.color;

      if (i === nextValues.length - 1 && sanitizedTier.to === undefined) {
        nextValues[i].to = undefined;
      }
      nextValues[i] = { ...nextValues[i], ...mergedTier };
      this.tierValues = nextValues;
      this.editDialog = false;
      this.tierPointChanged = true;

      this.$set(this.error.title, i, '');
      this.$set(this.error.description, i, '');
      this.getTiersErrors();
      this.rerenderDOM();
    },

    //Render the new tiers
    rerenderDOM() {
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },

    handleTierNumberChange() {
      if (this.tierValues.length !== this.currentTiersNumber) {
        let tempTiers = [...this.tierValues];
        if (tempTiers.length > this.currentTiersNumber) {
          for (let i = tempTiers.length; i > this.currentTiersNumber; i--) {
            this.removeTier();
          }
        } else if (tempTiers.length < this.currentTiersNumber) {
          for (let i = tempTiers.length; i < this.currentTiersNumber; i++) {
            this.addTier();
          }
        }
      }
    },

    adjustPreviousTierMaximumAmountAndValidate(i, tier) {
      if (i > 0) {
        this.validateMinimumAmount(i, tier, true);

        this.$nextTick(() => {
          this.getTiersErrors();
          let prevTier = this.tierValues[i - 1];
          if (prevTier) {
            prevTier.to = tier.from - 1;
          }
          this.$set(this.tierValues, i, tier);
        });
      }
    },
  },

  watch: {
    sliderValue(newVal) {
      // Prevent selecting the last tick (infinity)
      if (newVal === this.tierValues.length) {
        this.$nextTick(() => {
          this.sliderValue -= 1;
        });
      }
    },

    tiers: {
      handler(val, oldVal) {
        this.getTierValues();
        if (JSON.stringify(val) === JSON.stringify(oldVal) || this.updatingTiers)
          this.updatingTiers = true;
        this.$nextTick(() => {
          if (
            !this.tiersAreNewlyCreated &&
            (!this.savedTiers.length || JSON.stringify(val) === JSON.stringify(this.savedTiers))
          ) {
            this.tierPointChanged = false;
          } else {
            if (this.savedTiers.length !== val.length) {
              this.tierPointChanged = true;
            }
            val.forEach((e, i) => {
              if (
                !this.savedTiers[i] ||
                e.from !== this.savedTiers[i].from ||
                e.to !== this.savedTiers[i].to
              ) {
                this.tierPointChanged = true;
              }
            });
          }
          this.updatingTiers = false;
        });
      },
      deep: true,
    },

    ['tierValues.length']: {
      async handler(val, oldVal) {
        if (val) {
          if (val != this.currentTiersNumber) {
            this.currentTiersNumber = val;
          }
          await this.$nextTick(async () => {
            this.getTiersErrors();
          });
        }
      },
    },

    ['editDialog']: {
      async handler(val, oldVal) {
        await this.$nextTick(async () => {
          if (!val) {
            this.getTiersErrors();
          }
          this.rerenderDOM();
        });
      },
      deep: true,
    },

    tiersColors(newColors, oldColors) {
      this.injectTickStyles();
    },
  },
};
</script>

<style>
.tiers-slider .v-slider__tick:first-child > .v-slider__tick-label {
  margin-left: -4px;
}

/* Make only the last tick label bigger */
.v-slider__tick:last-child > .v-slider__tick-label {
  font-size: 1.4em;
  margin-left: 8px;
}

.v-slider__tick-label {
  cursor: pointer;
}

.tiers-slider >>> .v-slider__track-background {
  background: transparent !important; /* Hide default track */
}

.tiers-slider .v-slider__tick {
  height: 12px !important;
  z-index: 2;
}

.v-slider__thumb-label {
  z-index: 2;
  color: white;
}

.v-slider__track-fill.primary {
  width: 0% !important;
}

.tiers-slider .v-slider--horizontal {
  margin-left: 0 !important;
  margin-right: 0 !important;
  margin-top: 20px;
}
.tiers-slider .v-slider__thumb {
  z-index: 2;
}
.tiers-slider .v-slider__thumb.primary {
  background-color: #131212 !important;
}
.tiers-slider .v-input__slot {
  background-color: transparent !important;
}
.transition-all,
.transition-all * {
  transition:
    all 1s,
    width 2s,
    max-width 1s,
    min-width 1s,
    margin-left 2s,
    margin-top 2.5s,
    background-position 1.5s,
    opacity 1s;
}
.transition-all * {
  transition:
    all 1s,
    width 2s,
    max-width 1s,
    min-width 1s,
    margin-left 2s,
    margin-top 2.5s,
    background-position 1.5s,
    opacity 1s;
}
</style>

<style scoped>
.tier-title {
  background-color: #2a3042;
  min-height: 36px;
  width: 100% !important;
  color: white;
  cursor: pointer;
}

.tiers-container {
  width: 100%;
  white-space: nowrap;
  padding: 0 20px 50px 20px;
}

.tiers-container * {
  width: auto;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
}

.slider-wrapper {
  position: relative;
  width: 100%;
}

.custom-track {
  position: absolute;
  cursor: pointer;
  top: 50%;
  left: 12px;
  right: 12px;
  height: 4px;
  transform: translateY(-50%);
  display: flex;
  z-index: 1;
  width: 100%;
  left: 0;
}

.segment {
  flex: 1;
  min-height: 5px;
  height: 100%;
}

.tier-card-title {
  width: 100%;
}
.tier-edit-tooltip,
.tier-edit-btn {
  position: absolute !important;
  right: 4px;
}
.tiers-cards-container {
  max-width: 100%;
  margin-left: -8px;
  flex-wrap: wrap;
}
.custom-infinity-tick {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  font-size: 1.4em;
  color: black;
  background: white;
  padding: 0 8px;
  z-index: 2;
  pointer-events: none;
  max-height: 8px;
  margin-top: 4px;
  background: transparent;
  span {
    cursor: pointer;
    pointer-events: all;
  }
}
</style>
